import { useTranslation } from 'react-i18next';
import RunbookIcon from 'components/atoms/icons/runBookIcon';
import CircleIcon from 'components/atoms/icons/circleIcon';
import classNames from 'classnames';

import s from './styles.module.scss';

import type { FC } from 'react';

interface TriggerProps {
  toggleOpen: () => void;
  hasUpdate: boolean;
  setExpanded: (value: boolean) => void;
  isStandalone?: boolean;
  hasAssignToolNearby?: boolean;
}

const Trigger: FC<TriggerProps> = ({
  toggleOpen,
  hasUpdate,
  setExpanded,
  isStandalone = false,
  hasAssignToolNearby,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={classNames(s['run-book-trigger'], {
        [s.standalone]: isStandalone,
      })}
      id="run-book-trigger"
      data-cy="runBook-side-button"
      onClick={toggleOpen}
      data-move-down={hasAssignToolNearby}
    >
      <div
        className={s['trigger-content']}
        onClick={() => {
          setExpanded(false);
        }}
      >
        <span className={s['trigger-icon']}>
          {hasUpdate ? <CircleIcon /> : <RunbookIcon />}
        </span>
        <span className={s['minified-hidden']}>{t('runbook.runBook')}</span>
      </div>
    </div>
  );
};
export default Trigger;
